module.exports = __webpack_public_path__ + "static/media/terminalIcon.f5097505.svg";